import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import AuthModule from '@/store/modules/auth'
import LocalModule from '@/store/modules/local'
import AppModule from '@/store/modules/app'
import RegisterShop from '@/store/modules/registerShop'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: 'local:order',
  storage: window.localStorage,
  reducer: (state) => ({
    version: '0.0.1',
    local: state.local
  })
})

const store = new Vuex.Store({
  modules: {
    auth: AuthModule,
    local: LocalModule,
    app: AppModule,
    registerShop: RegisterShop
  },
  plugins: [
    vuexLocal.plugin
  ]
})

export default store
